export const NotificationStatusKeys = {
  success: 'success',
  error: 'error',
  // warning: 'warning',
}
